import User from './modules/User'
import Navigation from './modules/Navigation'
import FactoidsBlock from './modules/FactoidsBlock'
import TestimonialsBlock from './modules/TestimonialsBlock'
import CorporateMembersBlock from './modules/CorporateMembersBlock'
import AccordionBlock from './modules/AccordionBlock'
import PDFDownloadBlock from './modules/PDFDownloadBlock'
import MembershipBlock from './modules/MembershipBlock'
import FooterCTA from './modules/FooterCTA'
import BlogListing from './modules/BlogListing'
import ContactForm from './modules/ContactForm'
import Cart from './modules/Cart'
import RaffleTicketsBlock from './modules/RaffleTicketsBlock'

import SearchModal from './modules/SearchModal'
import TicketModal from './modules/TicketModal'
import ProductModal from './modules/ProductModal'
import CartModal from './modules/CartModal'
import BoardApplicationModal from './modules/BoardApplicationModal'
import CreateAccountModal from './modules/CreateAccountModal'
import StudentModal from './modules/StudentModal'

document.addEventListener('DOMContentLoaded', () => {
    //Safari polyfills
    if(/apple/i.test(navigator.vendor)) {
        document.querySelector('body').classList.add('--safari');
    }
    //Firefox polyfills
    if(navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
        document.querySelector('body').classList.add('--firefox');
    }

    window.theme.cart = new Cart();

    var navigation = document.querySelector('.js-navigation');
    if(navigation) {
        new Navigation(navigation);
    }

    var footer_cta = document.querySelector('.js-footer-cta');
    if(footer_cta) {
        new FooterCTA(footer_cta);
    }

    var factoids_block = document.querySelector('.js-factoids-block');
    if(factoids_block) {
        new FactoidsBlock(factoids_block);
    }

    var testimonial_blocks = document.querySelector('.js-testimonial-block');
    if(testimonial_blocks) {
        new TestimonialsBlock(testimonial_blocks);
    }

    var user_areas = document.querySelectorAll('.js-user');
    user_areas.forEach((user_area) => {
        new User(user_area);
    });

    var corporate_members_blocks = document.querySelectorAll('.js-corporate-members-block');
    corporate_members_blocks.forEach((corporate_members_block) => {
        new CorporateMembersBlock(corporate_members_block);
    });

    var membership_blocks = document.querySelectorAll('.js-membership-block');
    membership_blocks.forEach((membership_block) => {
        new MembershipBlock(membership_block);
    });

    var accordion_blocks = document.querySelectorAll('.js-accordion-block');
    accordion_blocks.forEach((accordion_block) => {
        new AccordionBlock(accordion_block);
    });

    var pdf_download_blocks = document.querySelectorAll('.js-pdf-download-block');
    pdf_download_blocks.forEach((pdf_download_block) => {
        new PDFDownloadBlock(pdf_download_block);
    });

    var search_modal = document.querySelector('.js-search-modal');
    if(search_modal) {
        new SearchModal(search_modal);
    }

    var ticket_modal = document.querySelector('.js-ticket-modal');
    if(ticket_modal) {
        new TicketModal(ticket_modal);
    }

    var product_modal = document.querySelector('.js-product-modal');
    if(product_modal) {
        new ProductModal(product_modal);
    }

    var cart_modal = document.querySelector('.js-cart-modal');
    if(cart_modal) {
        new CartModal(cart_modal);
    }

    var student_modal = document.querySelector('.js-student-modal');
    if(student_modal) {
        new StudentModal(student_modal);
    }

    var board_application_modal = document.querySelector('.js-board-application-modal');
    if(board_application_modal) {
        new BoardApplicationModal(board_application_modal);
    }

    var create_account_modal = document.querySelector('.js-create-account-modal');
    if(create_account_modal) {
        new CreateAccountModal(create_account_modal);
    }

    var blog_listings = document.querySelectorAll('.js-blog-listing');
    blog_listings.forEach((blog_listing) => {
        new BlogListing(blog_listing);
    });

    var contact_forms = document.querySelectorAll('.js-contact-us');
    contact_forms.forEach((contact_form) => {
        new ContactForm(contact_form);
    });

    var raffle_tickets_blocks = document.querySelectorAll('.js-raffle-tickets-block');
    raffle_tickets_blocks.forEach((raffle_tickets_block) => {
        new RaffleTicketsBlock(raffle_tickets_block);
    });
});
